import { render } from "./NavigationMenu.vue?vue&type=template&id=731c4624"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=731c4624&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__